import Styles from 'flows/common/steps/BrandKitInstructions/BrandKitInstructions.module.scss'
import { Text } from 'blaze-ui/Text/Text'

interface Props {
  title: string
}

export const MobileInstructions = ({ title }: Props) => (
  <div className={Styles.container}>
    <div className={Styles.imageContainer}>
      <img
        src="https://res.cloudinary.com/almanac/image/upload/v1739747014/onboarding_assets/Frame_1171275504_ax9eb8.png"
        className={Styles.heroImage}
        alt="Brand Kit Instructions"
      />
    </div>
    <span className={Styles.title}>{title}</span>
    <div className={Styles.section}>
      <span className={Styles.sectionTitle}>What's a brand kit?</span>
      <Text color="var(--dark-60">
        A personalized Brand Kit captures your voice, style, and visuals. No more generic AI content that sounds like
        everyone else.
      </Text>
    </div>
    <div className={Styles.section}>
      <span className={Styles.sectionTitle}>How do I create one?</span>
      <Text color="var(--dark-60)">
        Just paste in your website, and Blaze will automatically analyze your brand voice, pull your logo, colors, and
        fonts, and add any images and video to your BrandKit.
      </Text>
    </div>
  </div>
)
